import { TOKENS, HOME_ROUTES, LOGIN_ROUTES } from 'pages/auth/constants';
import { clearAllAlertsSearchCriteria } from 'common/Helpers/Alerts/AlertSearchCriteriaPeristence';

const getStateByRoute = (routeName, responseData) => {
  switch (routeName) {
    case LOGIN_ROUTES.PHONE_VERIFICATION:
      return {
        fromSignIn: true,
        resendContact: responseData.phoneVerificationDto?.is_resend_sms_enabled,
        contactType: responseData.phoneVerificationDto?.contact_type,
        message: responseData.reponse_msg
      };
    case LOGIN_ROUTES.QR_VERIFICATION:
      return {
        is_required: responseData.mfaDto.is_required,
        message: responseData.reponse_msg,
        shouldShowQr: responseData.mfaDto.should_initilize,
        mfa_qr_code_base64: responseData.mfaDto.mfa_qr_code_base64,
        mfa_manual_entry_key: responseData.mfaDto.mfa_manual_entry_key
      };
  }
};

export const routeTo = (routeName, data, navigate) => {
  return navigate(routeName, { state: getStateByRoute(routeName, data) });
};

export const setToken = (tokenKey, tokenValue) => {
  localStorage.setItem(tokenKey, JSON.stringify(tokenValue));
};

export const navigateToApp = (data, navigate) => {
  setToken(TOKENS.AUTH_TOKEN_SESSION_KEY, data.token);
  clearAllAlertsSearchCriteria();
  if (data?.globalModeState?.isGlobalMode && !data.globalModeState?.currentUserHasOnlyOneSite) {
    navigate(HOME_ROUTES.global);
  }
  // currently tv mode is not working so we comment the code
  // else if (data?.dashboardMode?.isTVModeEnable && data.dashboardMode.isDashboardUser) {
  //   setToken(TOKENS.TV_MODE_TOKEN, data.dashboardMode.tvToken);
  //   navigate(HOME_ROUTES.tv);
  // }
  else {
    navigate(HOME_ROUTES.local);
  }
};

export const loadify = (fn, setLoading) => {
  return async (...args) => {
    try {
      setLoading(true);
      const data = await fn(...args);
      setLoading(false);
      return data;
    } catch (e) {
      setLoading(false);
      throw e;
    }
  };
};

export const throwOnServerError = data => {
  let message = '';
  if (data.is_error_msg && data.reponse_msg) {
    try {
      // new backend error message format
      message = JSON.parse(data.reponse_msg)['message'];
      if (Array.isArray(message)) {
        message = message.join(', ');
      }
      message = message;
    } catch (e) {}
    throw message || data.reponse_msg;
  }
};
